import React, { FC, PropsWithChildren, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import chatImgIcon from '@assets/icons/chatImg.svg?url';

import Footer from './Footer';
import Header from './Header';
import useStyles from './styles.module';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { classes } = useStyles({ isOpen });

  return (
    <div className={classes.layout}>
      <Header />
      <div className={classes.container}>{children}</div>
      <Footer />
      {/* <iframe */}
      {/*   src="https://gia.prd.dexfinance.com/" */}
      {/*   title="сhat" */}
      {/*   className={classes.frame} */}
      {/* /> */}
      {/* <button */}
      {/*   className={classes.chat} */}
      {/*   onClick={() => setIsOpen((prevState) => !prevState)} */}
      {/* > */}
      {/*   {isOpen ? <KeyboardArrowDownIcon /> : <ChatImgIcon />} */}
      {/* </button> */}
    </div>
  );
};

export default Layout;
